import { render, staticRenderFns } from "./uploadNew.vue?vue&type=template&id=350b6946&scoped=true&"
import script from "./uploadNew.vue?vue&type=script&lang=ts&"
export * from "./uploadNew.vue?vue&type=script&lang=ts&"
import style0 from "./uploadNew.vue?vue&type=style&index=0&id=350b6946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350b6946",
  null
  
)

export default component.exports